import { Avatar, Button } from 'antd'
import ImageUpload from 'components/form/fields/ImageUpload'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import { IoCloudUploadOutline, IoPersonCircleOutline } from 'react-icons/io5'

const AvatarUploader = ({
  width = '80%',
  height = 200,
  onChange,
  name = 'avatar',
  Wrapper = 'div',
  icon = (
    <IoPersonCircleOutline
      size={45}
      className="text-color-500"
    />
  ),
}) => {
  const t = useTranslate()
  return (
    <Wrapper>
      <ImageUpload
        name={name}
        maxWidth={256}
        maxHeight={256}
        onChange={onChange}
        className="space-y-2"
        showUploadList={false}
        renderPreview={({ src }) => (
          <Avatar
            style={{ width: width, height: height }}
            src={src}
            icon={icon}
            className="flex flex-center background-200 rounded-lg"
          />
        )}>
        <Button
          size={'small'}
          className="button-rounded-md background-100 flex items-center gap-2">
          <IoCloudUploadOutline />
          <span className="font-medium text-xs">{t('avatar')}</span>
        </Button>
      </ImageUpload>
    </Wrapper>
  )
}

export default AvatarUploader
